import { useContext } from 'react';
import { Button } from '@chakra-ui/react';
import { ICON_BY_NAME } from '../Icons/Icon';
import { CbTooltip } from '../CbTooltip';
import CbReactionButton from './CbReactionButton';
import { getReactionCount, getReactionNames, reactionSentence } from './reactionHandler';
import styles from './CbReactions.module.css';
import { AuthContext } from 'providers';
import { emojiReactions } from './emojiReactions';
import { Reaction } from 'types/Reaction';
import { useReactions } from 'hooks';
interface CbReactionsProps {
  itemId: number;
  itemType: 'NewsfeedItem' | 'Comment';
  showHelperText: boolean;
  itemReactions: Reaction[];
}
const CbReactions = ({
  itemId,
  itemType,
  showHelperText,
  itemReactions
}: CbReactionsProps) => {
  const {
    auth
  } = useContext(AuthContext);
  const {
    reactions,
    onReact
  } = useReactions(itemId, itemType, itemReactions);
  const reactionCount = getReactionCount(reactions);
  const reactionUserNames = getReactionNames(reactions);
  function renderReactionList(reactions: Reaction[]) {
    return Object.keys(reactionCount).map((reaction, index) => <CbTooltip key={index} isLazy placement={'bottom'} width="400px" content={reactionSentence(reactionUserNames[reaction], reaction)}>
        <div className={styles.reactionListIcon}>
          <img className={styles.reactionIcon} src={emojiReactions[reaction]} />
          <p className={styles.reactionCountText}>{reactionCount[reaction]}</p>
        </div>
      </CbTooltip>);
  }
  function renderReactionMenu(onReact: (chosenReaction: string) => Promise<void>, userId: number, reactions: Reaction[]) {
    const userReactions = getUserReactions(reactions, userId);
    const availableReactions = Object.keys(emojiReactions);
    return <div data-sentry-component="renderReactionMenu" data-sentry-source-file="CbReactions.tsx">
        {availableReactions.map((reaction, i) => {
        const isSelected = userReactions.includes(reaction);
        return <CbReactionButton key={i} onReact={onReact} reaction={reaction} isSelected={isSelected} />;
      })}
      </div>;
  }
  function getUserReactions(reactions: Reaction[], id: number) {
    return reactions.filter(reaction => reaction.user.id === id).map(reaction => reaction.reaction);
  }
  return <div className={styles.reactionMenuContainer} data-sentry-component="CbReactions" data-sentry-source-file="CbReactions.tsx">
      {reactions.length === 0 ? showHelperText ? <p className={styles.reactionSubText}>{'Be the first to react'}</p> : <div /> : <div className={styles.usedReactions}>
          {renderReactionList(reactions)}
        </div>}
      <CbTooltip backgroundColor="white" placement="top" color="cloud.900" content={renderReactionMenu(onReact, auth.id, reactions)} data-sentry-element="CbTooltip" data-sentry-source-file="CbReactions.tsx">
        <Button className={styles.reactionButton} leftIcon={<ICON_BY_NAME.thumbsupfill color="cloud.800" />} variant="ghost" data-sentry-element="Button" data-sentry-source-file="CbReactions.tsx">
          {'React'}
        </Button>
      </CbTooltip>
    </div>;
};
export default CbReactions;